import type { MouseEventHandler } from 'react';
import React from 'react';

import CrossSymbol from '../../assets/CrossSymbolFilled.svg?react';
import { IconButton } from '../Buttons/IconButton';

import type { Level } from './types';

type Props = {
  level: Level;
  onClickClose?: MouseEventHandler<HTMLButtonElement>;
};

export const CloseButton: React.FC<Props> = ({ onClickClose, level }) => (
  <IconButton className="shrink-0 ml-xxs -mr-xxs" onClick={onClickClose} variant={level}>
    <CrossSymbol data-testid="close-notif" />
  </IconButton>
);
